<script setup>
import { computed } from 'vue';
import { CheckCircle, XCircle, AlertTriangle, Info, X } from '@lucide/vue';
import { useToastStore } from '@/stores/toast';

const toast = useToastStore();

const icons = {
    success: CheckCircle,
    error:   XCircle,
    warning: AlertTriangle,
    info:    Info,
};

// Powierzchnia nova: popover + ring tintowany statusem (bez klasy border)
const styles = {
    success: 'ring-success/30',
    error:   'ring-danger/30',
    warning: 'ring-warning/30',
    info:    'ring-foreground/10',
};

const iconStyles = {
    success: 'text-success',
    error:   'text-danger',
    warning: 'text-warning',
    info:    'text-muted-foreground',
};
</script>

<template>
    <Teleport to="body">
        <div
            class="fixed bottom-4 right-4 z-50 flex flex-col gap-2 pointer-events-none"
            style="max-width: 360px;"
        >
            <Transition
                v-for="t in toast.toasts"
                :key="t.id"
                appear
                enter-active-class="transition-all duration-200"
                enter-from-class="opacity-0 translate-y-2"
                enter-to-class="opacity-100 translate-y-0"
                leave-active-class="transition-all duration-150"
                leave-from-class="opacity-100 translate-y-0"
                leave-to-class="opacity-0 translate-y-1"
            >
                <div
                    data-testid="toast"
                    class="pointer-events-auto flex items-start gap-2.5 rounded-lg bg-popover text-popover-foreground ring-1 px-3.5 py-3 shadow-md text-sm"
                    :class="styles[t.type] ?? styles.info"
                >
                    <component
                        :is="icons[t.type] ?? icons.info"
                        class="h-4 w-4 shrink-0 mt-0.5"
                        :class="iconStyles[t.type] ?? iconStyles.info"
                    />
                    <span class="flex-1 leading-5">{{ t.message }}</span>
                    <button
                        class="shrink-0 opacity-50 hover:opacity-100 transition-opacity"
                        @click="toast.remove(t.id)"
                    >
                        <X class="h-4 w-4" />
                    </button>
                </div>
            </Transition>
        </div>
    </Teleport>
</template>
